// api.js
import {
  getTodoList
} from './../../../../api/api.p';

export async function fetchTodoList(params) {
  try {
    const res = await getTodoList(params);
    if (res) {
      if (res.meta.code === 0) {
        let lists = res;
        let list = lists.data;
        let data = list.records;
        if (data.length > 0) {
          data.forEach(ele => {
            let testArr = [];
            for (let key in ele.keyList) {
              testArr.push({
                'name': ele.keyList[key],
                'value': ele.valueList[key]
              });
            }
            ele.testArr = testArr;
          });
        }

        return lists;
      } else {
        return res;
      }
    }
  } catch (error) {
    throw error;
  }
}